/**
 * Stable 0..1 from a string seed (FNV-1a style). Use for deterministic animation
 * phase offsets that must not change across re-renders (e.g. idle bob desync).
 */
export function hashStringToUnit(seed: string): number {
	let h = 2_166_136_261;
	for (let i = 0; i < seed.length; i++) {
		h ^= seed.charCodeAt(i);
		h = Math.imul(h, 1_677_761_9);
	}
	return (h >>> 0) / 0xffff_fffe;
}

/** Maps a seed to `[0, cycleSec)` for `animation-delay` / phase offsets. */
export function resolveStableAnimationDelaySec(
	seed: string,
	cycleSec: number,
): number {
	return hashStringToUnit(seed) * cycleSec;
}
